import { useNavigate, useSearchParams } from 'react-router-dom'
import AuthUi from './auth/AuthUi.js'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

export default function Signup () {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const loginUrl = '/login' + (!searchParams ? '' : '?' + searchParams)

  function redirectWhenAuthenticated () {
    const next = searchParams.get('next')
    if (next) return navigate(next, { replace: true })
    else navigate('/dashboards', { replace: true })
  }

  return (
    <main className="flex items-center justify-center h-screen text-white text-center">
      <Helmet>
        <title>Signup</title>
      </Helmet>
      <section>
        <h1 className="text-3xl">Signup</h1>
        <AuthUi onAuth={redirectWhenAuthenticated} />
        <p className="text-gray-500 font-light text-sm">
          You already have an account?
          <Link to={loginUrl} className="underline ml-1">Log in</Link>
        </p>
      </section>
    </main>
  )
}
